export default __webpack_public_path__ + "6418bc168db00f1ae8f7ee97b047429e.png";